export enum ModeComponentEnum {
  Create = 'create',
  Update = 'update',
  View = 'view',
}
